<template lang="pug">
.header-space
    //- header
    //-     router-link.logo(to="/")
    //-         img.img(src="../assets/img/main-logo.svg")
</template>
<style lang="scss" scoped>
header {
    background: #fff;
    @include shadow;

    @media #{$pc} {
        border-bottom: 2px solid #eceff1;
        background: transparent;
        box-shadow: none;
    }
}
.logo {
    display: block;
    width: 120px;
    margin: 0 auto;
    padding-top: 16px;
    padding-bottom: 12px;

    > img {
        width: 100%;
    }
}

.header-space {
    padding: 96px;
}
</style>

<script>
export default {};
</script>
